import { Button } from "antd";
import { useTranslation } from "react-i18next";
import { cn } from "utils/helper";
import { MEETING_APP_OPTIONS } from "../meetingAdminApp";
import InternalCompanySelect from "./InternalCompanySelect";

// Field bersama "Kirim laporan ke AdminHebat" (khusus website internal).
// Wajib: app + perusahaan selalu harus dipilih (tidak bisa dimatikan).
// Controlled: value = { appId, company } (company = objek perusahaan).
const AdminHebatReportFields = ({
  contactId,
  contactLoading = false,
  value,
  onChange,
}) => {
  const { t } = useTranslation();
  const { appId, company } = value;

  const update = (patch) => onChange({ ...value, ...patch });

  // Judul sengaja di luar box agar sejajar dengan judul kolom di sebelahnya.
  return (
    <div className="space-y-2">
      <p className="mb-0 text-sm font-semibold text-neutral-800">
        {t("meeting_finished.send_report_to_adminhebat")}
      </p>

      <div className="space-y-3 rounded-lg border border-neutral-200 p-3">
        <div className="space-y-1.5">
          <p className="mb-0 text-xs font-medium text-neutral-500">
            {t("meeting_finished.select_app")}
          </p>
          <div className="flex flex-wrap gap-2">
            {MEETING_APP_OPTIONS.map((app) => (
              <Button
                key={app.value}
                type={appId === app.value ? "primary" : "default"}
                className={cn(appId === app.value && "font-semibold")}
                // Ganti app → reset perusahaan (beda app, beda daftar).
                onClick={() => update({ appId: app.value, company: null })}
              >
                {app.label}
              </Button>
            ))}
          </div>
        </div>

        <div className="space-y-1.5">
          <p className="mb-0 text-xs font-medium text-neutral-500">
            {t("company")}
          </p>
          <InternalCompanySelect
            appId={appId}
            contactId={contactId}
            contactLoading={contactLoading}
            selected={company}
            onChange={(c) => update({ company: c })}
          />
        </div>
      </div>
    </div>
  );
};

export default AdminHebatReportFields;
